import store from '@/store'

export function setToken(token) {
  const tokenMap = {...token};
  for (const key in tokenMap) {
    localStorage[key] = tokenMap[key];
  }

  tokenMap.logTime = Date.parse(new Date()) + tokenMap.expires_in * 1000;
  localStorage['logTime'] = Date.parse(new Date()) + tokenMap.expires_in * 1000; 
  let accessToken = store.getters.objApi.LOCAL_URL.substr(store.getters.objApi.LOCAL_URL.indexOf("://") + 3);
  /**
   * 设置两种域名的token字段
   * 1. 一种末尾带/
   * 2. 一种末尾不带/
   */
  localStorage[accessToken] = JSON.stringify(tokenMap);
  localStorage[accessToken + '/'] = JSON.stringify(tokenMap);
  localStorage[accessToken.replace('/fe', '/')] = JSON.stringify(tokenMap);
  localStorage[accessToken.replace('/fe', '')] = JSON.stringify(tokenMap);
  // window.location.href = store.getters.objApi.LOCAL_URL;
}

export function getToken() {
  if (localStorage.refresh_token && localStorage.access_token) {
    const { access_token, token_type, logTime, refresh_token} = localStorage;
    return { access_token, token_type, logTime, refresh_token };
  }else {
    return null;
  }

}

export function clearToken() {
  return new Promise((reslove, reject) => {
    if (localStorage.isRember) {
      let remberLogin = localStorage.isRember;
      sessionStorage.clear();
      localStorage.clear();
      localStorage.isRember = remberLogin;
      reslove();
    } else {
      sessionStorage.clear();
      localStorage.clear();
      reslove();
    }
  }).catch(error => {
    reject(error);
  })

}



// WEBPACK FOOTER //
// ./src/utils/auth.js